const CORRECTION_WINDOW_MS = 2000;
const DRIFT_THRESHOLD = 4;
const FONTS_TIMEOUT_MS = 2500;

if ( 'scrollRestoration' in history ) {
	history.scrollRestoration = 'manual';
}

function waitForFonts() {
	if ( !document.fonts || !document.fonts.ready ) {
		return Promise.resolve();
	}

	return Promise.race( [
		document.fonts.ready,
		new Promise( ( resolve ) => setTimeout( resolve, FONTS_TIMEOUT_MS ) ),
	] );
}

function getHeaderHeight() {
	const header = document.querySelector( '.section-header' );

	return header ? header.offsetHeight : 0;
}

function isRealHashLink( href ) {
	if ( !href ) {
		return false;
	}

	const hashIndex = href.indexOf( '#' );

	return hashIndex !== -1 && hashIndex < href.length - 1;
}

function getHashTarget( hash ) {
	if ( !hash || hash.length < 2 ) {
		return null;
	}

	return document.getElementById( hash.slice( 1 ) );
}

function computeTargetTop( target ) {
	return target.getBoundingClientRect().top + window.scrollY - getHeaderHeight();
}

async function scrollToHash( hash, href, behavior ) {
	const target = getHashTarget( hash );

	if ( !target ) {
		return;
	}

	await waitForFonts();

	if ( !document.body.contains( target ) ) {
		return;
	}

	let lastTargetTop = computeTargetTop( target );

	window.scrollTo( { top: lastTargetTop, left: 0, behavior } );

	if ( href && window.location.hash !== hash ) {
		history.pushState( null, '', href );
	}

	const start = performance.now();

	function correctLoop() {
		if ( !document.body.contains( target ) ) {
			return;
		}

		const targetTop = computeTargetTop( target );

		if ( Math.abs( targetTop - lastTargetTop ) > DRIFT_THRESHOLD ) {
			lastTargetTop = targetTop;
			window.scrollTo( { top: targetTop, left: 0, behavior: 'auto' } );
		}

		if ( performance.now() - start >= CORRECTION_WINDOW_MS ) {
			return;
		}

		requestAnimationFrame( correctLoop );
	}

	requestAnimationFrame( correctLoop );
}

$( document ).on( 'click.scrollHashFix', 'a[href*="#"]', function( e ) {
	const href = $( this ).attr( 'href' );

	if ( !isRealHashLink( href ) ) {
		return;
	}

	const hash = href.slice( href.indexOf( '#' ) );
	const target = getHashTarget( hash );

	if ( !target ) {
		return;
	}

	e.preventDefault();
	scrollToHash( hash, href, 'smooth' );
} );

window.addEventListener( 'popstate', () => {
	if ( window.location.hash ) {
		scrollToHash( window.location.hash, null, 'auto' );
	}
} );

if ( window.location.hash ) {
	scrollToHash( window.location.hash, null, 'auto' );
}
